"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidePanel = void 0;
var react_1 = __importDefault(require("react"));
var Drawer_1 = __importDefault(require("@material-ui/core/Drawer"));
var system_1 = require("../system");
var utils_1 = require("../utils");
var useStyles = (0, system_1.makeStyles)(function (theme) { return ({
    paper: __assign(__assign({}, theme.go.mixins.paper), { border: 'none', boxSizing: 'border-box', '& *': {
            boxSizing: 'border-box',
        } }),
    paperAnchorRight: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        '[dir="rtl"] &': __assign(__assign({}, theme.go.mixins.paper), { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
    },
    paperAnchorLeft: {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        '[dir="rtl"] &': __assign(__assign({}, theme.go.mixins.paper), { borderTopRightRadius: 0, borderBottomRightRadius: 0 }),
    },
    paperAnchorTop: {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
    },
    paperAnchorBottom: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
    },
    backdrop: {
        backgroundColor: (0, utils_1.changeAlpha)(theme.go.schemes.colors.system.BgInvert, 0.4),
    },
}); });
function SidePanel(_a) {
    var classes = _a.classes, ModalProps = _a.ModalProps, BackdropComponent = _a.BackdropComponent, props = __rest(_a, ["classes", "ModalProps", "BackdropComponent"]);
    var _b = useStyles(), paper = _b.paper, paperAnchorRight = _b.paperAnchorRight, paperAnchorLeft = _b.paperAnchorLeft, paperAnchorBottom = _b.paperAnchorBottom, paperAnchorTop = _b.paperAnchorTop, backdrop = _b.backdrop;
    return (react_1.default.createElement(Drawer_1.default, __assign({}, props, { SlideProps: __assign({ appear: true }, props.SlideProps), classes: __assign(__assign({}, classes), { paper: (0, utils_1.cn)(paper, classes === null || classes === void 0 ? void 0 : classes.paper), paperAnchorRight: (0, utils_1.cn)(paperAnchorRight, classes === null || classes === void 0 ? void 0 : classes.paperAnchorRight), paperAnchorLeft: (0, utils_1.cn)(paperAnchorLeft, classes === null || classes === void 0 ? void 0 : classes.paperAnchorLeft), paperAnchorBottom: (0, utils_1.cn)(paperAnchorBottom, classes === null || classes === void 0 ? void 0 : classes.paperAnchorBottom), paperAnchorTop: (0, utils_1.cn)(paperAnchorTop, classes === null || classes === void 0 ? void 0 : classes.paperAnchorTop) }), elevation: 0, ModalProps: __assign(__assign(__assign({}, (BackdropComponent ? { BackdropComponent: BackdropComponent } : {})), ModalProps), { BackdropProps: {
                classes: {
                    root: backdrop,
                },
            } }) })));
}
exports.SidePanel = SidePanel;
